import React, { useState } from "react";
import PropTypes from "prop-types";
import TooltipButton from "../../ui/tooltip-button";
import Disclaimer from "../../ui/disclaimer";
import { fireEvent } from "../../../utils/google-analytics-handler";
import removeIcon from "../../../assets/img/shredder.svg";

const PendingActions = ({ onDeleteClick, onViewDetailClick }) => {
  const [visibleDialog, setVisibleDialog] = useState(false);
  return (
    <div className="pending-actions-container">
      <TooltipButton
        buttonClassName="btn-action"
        onClick={() => setVisibleDialog(true)}
        iconClassName="icono-trash"
        tooltipText="Eliminar transferencia"
      />
      <TooltipButton
        buttonClassName="btn-action"
        onClick={() => onViewDetailClick()}
        iconClassName="icono-arrow-right-simple"
        tooltipText="Ver propuesta de conciliación"
      />
      <Disclaimer
        icon={<img src={removeIcon} alt="Eliminar partida" />}
        title="Eliminar transferencia"
        text="¿Desea eliminar esta transferencia?. Esta acción no se puede deshacer."
        visible={visibleDialog}
        acepptButtonText="Eliminar"
        cancelButtonText="Cancelar"
        onCancel={() => setVisibleDialog(false)}
        onAccept={() => {
          setVisibleDialog(false);
          onDeleteClick();
          fireEvent("Conciliation", "DELETE");
        }}
      />
    </div>
  );
};

PendingActions.propTypes = {
  onDeleteClick: PropTypes.func,
  onViewDetailClick: PropTypes.func
};

PendingActions.defaultProps = {
  onDeleteClick: () => {},
  onViewDetailClick: () => {}
};

export default PendingActions;
